import React from 'react';
import { Flex } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { StyledInputContainer } from '@withjoy/joykit/components/InputV1/StyledInputContainer';

export const StyledHotelInputContainer = ({
  children,
  isHotelInvalid,
  errorHotel,
}: Readonly<{
  children: React.ReactNode;
  isHotelInvalid?: boolean;
  errorHotel?: string;
}>) => (
  <Flex
    __css={{
      ['& > div']: {
        width: '100% !important',
      },
      [`${StyledInputContainer}`]: {
        border: isHotelInvalid || errorHotel ? '1px solid #c50020' : '1px solid transparent',
        borderRadius: 999,
        _after: {
          border: '0px solid transparent',
          borderRadius: 999,
          boxShadow: isHotelInvalid || errorHotel ? '0px 0 0px 1px #c50020' : '0px 0 0px 1px #333',
          content: '" "',
          height: '100%',
          width: '100%',
          position: 'absolute',
          top: 0,
          bottom: 0,
          right: 0,
          left: 0,
        },
        ['input']: {
          outline: 0,
          color: 'mono14',
          borderRadius: 999,
          _hover: {
            borderColor: isHotelInvalid || errorHotel ? 'negative6' : 'mono14',
          },
          _focus: { outline: 0, borderColor: isHotelInvalid || errorHotel ? 'negative6' : 'mono14' },
          fontSize: '1rem !important',
        },
        ['textarea']: {
          outline: 0,
          _focus: { outline: 0 },
          fontSize: '1rem !important',
        },
      },
    }}
  >
    {children}
  </Flex>
);

export const StyledTextAreaContainer = ({
  children,
  isInvalid,
}: Readonly<{
  children: React.ReactNode;
  isInvalid?: boolean;
}>) => (
  <Flex
    __css={{
      ['& > div']: {
        width: '100% !important',
        height: '100%',
      },
      ['textarea']: {
        minHeight: pxToRem(112),
        maxHeight: pxToRem(400),
        width: '100%',
        minWidth: '100%',
        outline: 0,
        borderRadius: pxToRem(6),
        border: '0px solid',
        boxShadow: isInvalid ? '0px 0 0px 2px #c50020' : '0px 0 0px 1px #D9D9D9',
        _hover: { border: '0px solid', boxShadow: isInvalid ? '0px 0 0px 2px #c50020' : '0px 0 0px 1px #333' },
        _focus: { outline: 0, boxShadow: isInvalid ? '0px 0 0px 2px #c50020' : '0px 0 0px 2px #333' },
        color: 'mono14',
        fontSize: '1rem !important',
      },
    }}
  >
    {children}
  </Flex>
);
